import { useState } from 'react';
import { useMutation } from '@apollo/client/react';

import { CALCULATE_PAYMENT_PLAN } from 'mutations/prechargeoff';

const usePaymentPlanQuery = () => {
  const [schedule, setSchedule] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const [calculatePaymentPlan] = useMutation(CALCULATE_PAYMENT_PLAN);

  const retrievePaymentPlan = async ({
    amount,
    startDate,
    cadence,
    endDate,
  }) => {
    setLoading(true);
    setError(false);
    setSchedule([]);
    try {
      const { data } = await calculatePaymentPlan({
        variables: {
          totalAmount: amount,
          startDate,
          cadence,
          endDate,
        },
      });

      setSchedule(data.calculatePaymentPlan.payments);
      setLoading(false);
    } catch {
      setError(true);
      setLoading(false);
    }
  };

  const resetError = () => setError(false);

  return {
    retrievePaymentPlan,
    resetError,
    schedule,
    loading,
    error,
  };
};

export default usePaymentPlanQuery;
